"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPercentageValue = getPercentageValue;
exports.getMultiplierRounded = getMultiplierRounded;
exports.getMultiplierFloor = getMultiplierFloor;
exports.getMultiplierCeil = getMultiplierCeil;
exports.getNearestValueIndex = getNearestValueIndex;
exports.isAscending = isAscending;
exports.sortAscending = sortAscending;
exports.convertToPercentage = convertToPercentage;
exports.valueMatchMin = valueMatchMin;
exports.valueMatchMax = valueMatchMax;
exports.valueMatchRange = valueMatchRange;
exports.constrainMaxValue = constrainMaxValue;
exports.constrainMinValue = constrainMinValue;

var _types = require("./types");

function getPercentageValue(value, percentage) {
  return value / 100 * percentage;
}

function getMultiplierRounded(value, multiplier) {
  return Math.round(value / multiplier) * multiplier;
}

function getMultiplierFloor(value, multiplier) {
  return Math.floor(value / multiplier) * multiplier;
}

function getMultiplierCeil(value, multiplier) {
  return Math.ceil(value / multiplier) * multiplier;
}

function getNearestValueIndex(value) {
  var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var closest = arr.reduce(function (prev, curr) {
    var currentDiff = Math.abs(curr - value);
    var prevDiff = Math.abs(prev - value);

    if (currentDiff < prevDiff) {
      return curr;
    }

    return prev;
  });
  return arr.findIndex(function (v) {
    return v === closest;
  });
}

function isAscending() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return arr.slice(1).map(function (v, i) {
    return v > arr[i];
  }).every(function (val) {
    return val;
  });
}

function sortAscending() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return arr.sort(function (a, b) {
    return a - b;
  });
}

function convertToPercentage(children, parent) {
  return children / parent * 100;
}

function valueMatchMin(value, min) {
  return value && (0, _types.isNumber)(value) && value >= min;
}

function valueMatchMax(value, max) {
  return value && (0, _types.isNumber)(value) && value <= max;
}

function valueMatchRange(value, max, min) {
  return valueMatchMax(value, max) && valueMatchMin(value, min);
}

function constrainMaxValue(value, max) {
  if (value && (0, _types.isNumber)(value)) {
    if (!valueMatchMax(value, max)) {
      return max;
    }

    return value;
  }

  return null;
}

function constrainMinValue(value, min) {
  if (value && (0, _types.isNumber)(value)) {
    if (!valueMatchMin(value, min)) {
      return min;
    }

    return value;
  }

  return null;
}